import React from 'react';
import {Scale} from '../Scale';
import PropTypes from 'prop-types';
import {Tooltip} from '../Tooltip';
import {getTooltipLeft} from '../RangeSlider.utils';

export function TooltipAndScale(props) {
  const tooltipStyle = (value) =>
    getTooltipLeft({
      value,
      min: props.min,
      max: props.max,
      ele: props.wrapRef.current,
    });

  const showTooltip = () =>
    props.show && props.wrapRef && props.wrapRef.current;

  const showScale = () => props.wrapRef && props.wrapRef.current;

  return (
    <>
      {showTooltip() && (
        <Tooltip
          unit={props.unit}
          value={props.value}
          tooltipStyle={tooltipStyle(props.value)}
        />
      )}
      {props.children}
      {showScale() && (
        <Scale
          min={props.min}
          max={props.max}
          unit={props.unit}
          scaleInterval={props.scaleInterval}
          getPostionLeft={tooltipStyle}
        />
      )}
    </>
  );
}

TooltipAndScale.propTypes = {
  /**
   * boolean to show/hide tooltip
   */
  show: PropTypes.bool,
  /**
   * Input Slider component to which the tooltip is displayed
   */
  children: PropTypes.element,
  /**
   * Current slider value to display on slider
   */
  value: PropTypes.number,
  /**
   * The unit for the scale value
   */
  unit: PropTypes.string,
  /**
   * Min value
   */
  min: PropTypes.number,
  /**
   * Max value
   */
  max: PropTypes.number,
  /**
   * Reference to SliderComponent
   */
  wrapRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({current: PropTypes.instanceOf(Element)}),
  ]),
};

TooltipAndScale.defaultProps = {};
